import { Required } from '@decorators/entity-required.decorator';

export class User {
	@Required
	id: string;
	
	@Required
	userName: string;

	@Required
	firstName: string;

	@Required
	lastName: string;

	@Required
	email: string;

	@Required
	kaliticsKey: string;
}